'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createAvailability;

var _Time2 = require('../helpers/Time.js');

var _Time3 = _interopRequireDefault(_Time2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createAvailability() {
    var fixture = { weekly: [], exceptions: [] };

    return {
        addWeeklyFromDate: function addWeeklyFromDate(_ref) {
            var _ref$_Time = _ref._Time,
                _Time = _ref$_Time === undefined ? _Time3.default : _ref$_Time,
                start = _ref.start,
                end = _ref.end;

            var startMinute = Math.floor(_Time.getMinuteOfWeek(start));
            var endMinute = Math.floor(_Time.getMinuteOfWeek(end));
            var duration = endMinute - startMinute;
            fixture.weekly.push({ minuteOfWeek: startMinute, durationMins: duration });
            return this;
        },
        addWeeklyFromMinuteOfWeek: function addWeeklyFromMinuteOfWeek(_ref2) {
            var start = _ref2.start,
                end = _ref2.end;

            var duration = end - start;
            fixture.weekly.push({ minuteOfWeek: start, durationMins: duration });
            return this;
        },
        addException: function addException(_ref3) {
            var start = _ref3.start,
                end = _ref3.end,
                available = _ref3.available,
                reason = _ref3.reason,
                comment = _ref3.comment;

            fixture.exceptions.push({ start: start, end: end, available: available, reason: reason, comment: comment });
            return this;
        },
        val: function val() {
            return fixture;
        }
    };
}